import ArrowRightIcon from "../../../assets/icons/ArrowRightIcon"
import ArrowDownIcon from "../../../assets/icons/ArrowDownIcon"
import GreenTickIcon from "../../../assets/icons/GreenTickIcon"
import React, { useEffect, useState } from "react";
import { useCart } from "@shopify/hydrogen/client";
import axios from "axios"
import { CustomizeProduct, Group, ProductMetafields, ShopSettings, VariantEdgeMetafields } from "~/types";
import { CartLineInput } from "@shopify/hydrogen/storefront-api-types";
import BlackCircleLoading from "~/assets/icons/BlackCircleLoading";
import { getCurrencyValue } from "~/lib/utils";
import ArrowLeftIcon from "~/assets/icons/ArrowLeftIcon";
import QuoteButton from "./QuoteButton.client";
import { retailSystem } from "../../../../setup/settings/index";
import { bigFurnitureShow, customize, showPriceOptions, showOptionTextHover, digitalagent, disabledAddToBasket, leadtime, setupCustomSectionOption, showOldPriceCustomizeModal, stockRequestInfo } from "../../../../setup/settings/__product";
import VariantModal from "../variant/VariantModal.client";
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../../setup/settings/__nonTransactional";
import getOverlappingDaysInIntervals from "date-fns/esm/fp/getOverlappingDaysInIntervals/index";
import { DayPickerProvider } from "react-day-picker";
import { addToBasketButtonName } from "../../../../setup/settings/__cart";
import { showImageAtCustomizeSelection } from "../../../../setup/settings/__product";
import SetupCustomSectionOption from "../../../../setup/components/setup/productDetail/SetupCustomSectionOption.client";
import ArrowLeftCarousel from "~/assets/icons/ArrowLeftCarousel";
import CarouselArrows from "./CarouselArrows";
import IndexPoints from "./IndexPoints";
import GroupSelector from "./GroupSelector";
import NoImageMultiStore from '../../../../setup/assets/options_missing.png';

type CustomizeModalProps =
    {
        product: ProductMetafields,
        show: boolean,
        close: () => void,
        openCart: () => void,
        variant: VariantEdgeMetafields | undefined,
        addVariantBasket: (variant: any) => void,
        currency: string,
        modalType: number,
        shopSettings: ShopSettings,
        stockErrorMessage: string | null,
    }

export default function CustomizeModal({ currency, product, show, close, openCart, variant,
    addVariantBasket, modalType, shopSettings, stockErrorMessage }: CustomizeModalProps) {

    const clickClose = () => { close(); }
    const cart = useCart()
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [optionsSelected, setOptionsSelected] = useState<any[]>([]);
    const customizeOptions: CustomizeProduct[] = JSON.parse(product.customizeOptions?.value || '[]');
    const [variantSelect, setVariantSelect] = useState<VariantEdgeMetafields | undefined>();
    const [viewImageOption, setViewImageOption] = useState<boolean>(false);

    const [optionWithImageClick, setOptionWithImageClick] = useState<any>();
    const disableButton = JSON.parse(product.customField?.value || '{}').disableaddtocartbutton ?? false;
    const priceLevel = JSON.parse(product.customField?.value || '{}').pricelevel ?? "";


    const [variantIdToAddCart, setVariantIdAddCart] = useState<any>("")
    const [optionCartLineToAddCart, setOptionCartLineToAddCart] = useState<any>([])
    const [initCart, setInitCart] = useState<boolean>(false)

    const isDisabled = () => {
        return (optionsSelected.length != customizeOptions.length || total == 0) || disabledAddToBasket;
    }

    useEffect(() => {
        setVariantSelect(variant);
    }, [show])

    useEffect(() => {
        if (variant) {
            const options = [];
            variant.node.basePriceOptions && options.push(...JSON.parse(variant.node.basePriceOptions?.value));
            variant.node.options && options.push(...JSON.parse(variant.node.options?.value));
            variant.node.addOnOptions && options.push(...JSON.parse(variant.node.addOnOptions?.value));
            const newList: any[] = [];
            options.forEach(o => {
                const option = customizeOptions.find(co => co.Groups.find(g => g.Options.find(op => op.Id == o.Id)))
                newList.push({ title: option?.Title, option: option?.Groups[0].Options[0] })
            })
            setOptionsSelected(newList);
        }
    }, [variantSelect])

    useEffect(() => {
        if (variant) {
            const options = [];
            variant.node.basePriceOptions && options.push(...JSON.parse(variant.node.basePriceOptions?.value));
            variant.node.options && options.push(...JSON.parse(variant.node.options?.value));
            variant.node.addOnOptions && options.push(...JSON.parse(variant.node.addOnOptions?.value));
            const newList: any[] = [];
            options.forEach(o => {
                const option = customizeOptions.find(co => co.Groups.find(g => g.Options.find(op => op.Id == o.Id)))
                newList.push({ title: option?.Title, option: option?.Groups[0].Options[0] })
            })
            setOptionsSelected(newList);
            setVariantSelect(variant);
        }
        else {
            setVariantSelect(undefined);
            setOptionsSelected([]);
        }

    }, [variant])

    const addToBasket = async () => {

        if (isDisabled()) return;
        setLoading(true);
        const options = optionsSelected.map(os => os.option.Id);
        const productSplitId = product.id.split('/');
        const productId = productSplitId[productSplitId.length - 1];

        const payload = {
            price: `${total}`,
            optionIds: options,
            productId: productId
        };

        const variantId = await axios.post(retailSystem.apiRS, payload);
        let optionCartLine: any[] = [];
        optionsSelected.forEach(o => {
            const option = customizeOptions.find(co => co.Id == o.Id);
            optionCartLine.push({ option: o?.option, group: option?.Title })
            optionCartLine = optionCartLine.filter(n => n.group != 'Base price')
        })

        const attributes: { key: string; value: string }[] =
            optionCartLine.map(item => {
                return {
                    key: item?.group?.replace(':', '').toUpperCase(),
                    value: item?.option?.Title
                };
            }) ?? [];

        const line: CartLineInput = {
            merchandiseId: `gid://shopify/ProductVariant/${variantId.data}`,
            quantity: 1,
            attributes: (attributes?.length > 0 ? attributes : [])
        }

        cart.linesAdd([line]);
        let tokenKey = cart.id?.split('/') ? cart.id?.split('/')[cart.id?.split('/').length - 1] : "";
        const cartToken = tokenKey.split('?')[0];
        if (cartToken != "") {
            addOptionCache(variantId, optionCartLine, cartToken)
            setLoading(false);
            close();
            openCart();
        } else {
            setVariantIdAddCart(variantId)
            setOptionCartLineToAddCart(optionCartLine)
            setInitCart(true)
            setLoading(false);
            close();
        }
    }

    const isFirstOpenCart = () => {
        return initCart && cart.status == "idle" && cart.id != undefined && cart.id != "" && optionCartLineToAddCart && variantIdToAddCart;
    }

    useEffect(() => {
        if (isFirstOpenCart()) {
            let tokenKey = cart.id?.split('/') ? cart.id?.split('/')[cart.id?.split('/').length - 1] : "";
            const cartToken = tokenKey.split('?')[0];
            addOptionCache(variantIdToAddCart, optionCartLineToAddCart, cartToken)
            setVariantIdAddCart("")
            setOptionCartLineToAddCart([])
            setInitCart(false);
            openCart();
        }
    }, [cart.status, initCart])


    const addOptionCache = async (variantId: any, optionCartLine: any[], token: string) => {
        try {
            const optionPayload = {
                "cartid": token,
                "cartLineItems": [
                    {
                        "lineItemId": variantId.data,
                        "options": optionCartLine,
                    }
                ]
            };

            const response = await axios.post(`${retailSystem.cartCache}/AddCartVariantOptions`, optionPayload);
            console.log('Respuesta POST:', response.data);
        } catch (error) {
            console.error('Error en la solicitud POST:', error);
        }
    };

    const addOption = (Id: string, option: any) => {
        const newList = optionsSelected.filter(os => os.Id != Id);
        newList.push({ Id, option: option })
        setOptionsSelected(newList);
    }

    const viewImage = (option: any) => {
        if (option.Image) {
            setViewImageOption(true);
            setOptionWithImageClick(option)
        }
    }
    const clickCloseViewImage = () => {
        setViewImageOption(false);
    }

    useEffect(() => {
        let total = 0.00;
        optionsSelected.forEach(os => {
            total += os.option?.Price?.From ?? 0;
        })
        setTotal(total);
    }, [optionsSelected])

    const isSelected = (Id: string, option: any) => {
        const exist = optionsSelected.findIndex(os => os.Id == Id && os.option?.Title == option.Title);
        return exist != -1;
    }

    const hasValue = (Id: string) => {
        return optionsSelected.filter(os => os.Id == Id);
    }

    const changeCustomize = () => {
        setOptionsSelected([]);
        setVariantSelect(undefined);
    }

    const parsePriceIcon = (optionName: string) => {
        if (optionName == "TopPrice") return "££££";
        if (optionName == "MidToTopPrice") return "£££";
        if (optionName == "MidPrice") return "££";
        if (optionName == "LowPrice") return "£";
        return optionName;
    }


    const ContentModal = () => {

        const [viewModalLeft, setViewModalLeft] = useState<boolean>(false);
        const [viewImageModalLeftOption, setViewViewImageModalLeftOption] = useState<any>(null);

        const imageModalLeft = (option: any) => {
            if (option.Image) {
                setViewModalLeft(true)
                setViewViewImageModalLeftOption(option)
            } else {
                setViewModalLeft(false)
            }
        }
        const mouseOutLeft = () => {
            setViewModalLeft(false)
        }

        return <>
            <div className={`${viewImageOption ? 'hidden' : ''}`} >
                <span className="back" onClick={clickClose}><ArrowLeftIcon color="black" /></span>
                <h2>{product.title}</h2>
                <div className="price">
                    {priceLevel == "" &&
                        <span>
                            <span>Customize:</span>
                            {(!isNonTransactional || showPriceshowPriceTransactional) && product.priceRange && showPriceRange(JSON.parse(product.priceRange?.value)[0], JSON.parse(product.priceRange?.value)[1])}
                        </span>
                    }
                    {product.customField?.value && JSON.parse(product.customField.value)?.leadtime && (
                        <p>{leadtime.text} : {JSON.parse(product.customField.value).leadtime}</p>
                    )}
                </div>
                <p>Select:</p>
                {customizeOptions.sort((a, b) => a.Title.localeCompare(b.Title)).map(co => co.Title != 'Base price' &&
                    <Option viewImage={viewImage} currency={currency} option={co} hasValue={hasValue} isSelected={isSelected}
                        addOption={addOption} disabled={variantSelect != undefined}
                        setViewImageModalLeft={imageModalLeft} mouseOutLeft={mouseOutLeft} />
                )}
                {!bigFurnitureShow && <>
                    {variantSelect == undefined ?
                        (
                            <>
                                <QuoteButton price={total} disabled={isDisabled()} optionsSelected={optionsSelected} customizeOptions={customizeOptions} product={product} close={close} />
                                {!disableButton && !isNonTransactional &&
                                    <span className={`black-button ${isDisabled() && 'disabled'}`} onClick={addToBasket}>
                                        {loading ? <div className="text-center">LOADING  <BlackCircleLoading /></div>
                                            : ((priceLevel != "" && !digitalagent) ? `${addToBasketButtonName.default ? 'ADD TO BASKET' : addToBasketButtonName.name}- ${parsePriceIcon(priceLevel)}`
                                                : `${addToBasketButtonName.default ? 'ADD TO BASKET' : addToBasketButtonName.name} - ${getCurrencyValue(currency, `${total}`)}`)}
                                    </span>
                                }
                            </>
                        ) :
                        (<>
                            {product.customizeOptions?.value && <div className="customize-button-variant" onClick={changeCustomize}><span>Customize Your Product</span> →</div>}
                            <>
                                <QuoteButton price={total} variant={variant} optionsSelected={optionsSelected} customizeOptions={customizeOptions} product={product} close={close} />
                                {product.customizeOptions?.value && disableButton == 'false' &&
                                    <div className="customize-button-variant" onClick={changeCustomize}>
                                        <span>Customize Your Product</span> →
                                    </div>}
                                {disableButton == 'false' && !isNonTransactional &&
                                    <span className={`black-button`} onClick={() => addVariantBasket(variant)}>
                                        ${addToBasketButtonName.default ? 'ADD TO BASKET' : addToBasketButtonName.name} - {getCurrencyValue(currency, variantSelect.node?.price.amount)}
                                    </span>
                                }
                            </>
                        </>
                        )}
                </>}
            </div>
            <div className={`${!viewImageOption ? 'hidden' : ''}`}>
                <ViewImageModalOption clickCloseViewImage={clickCloseViewImage} option={optionWithImageClick} />
            </div>
            <div className={`${!viewModalLeft ? 'hidden' : ''}`}>
                <ViewImageModalLeft option={viewImageModalLeftOption} />
            </div>
        </>;
    }

    useEffect(() => {
        const basePrice = customizeOptions.find(co => co.Title == 'Base price');
        if (basePrice) {
            addOption(basePrice?.Id, basePrice?.Groups[0].Options[0]);
        }
    }, [variantSelect])

    const showPriceRange = (from: string, to: string) => {
        if (from == to) return getCurrencyValue(currency, from);
        else return `${getCurrencyValue(currency, from)} - ${getCurrencyValue(currency, to)}`;
    }

    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (stockRequestInfo.enabled && stockErrorMessage !== null) {
            setIsVisible(true);

            const timer = setTimeout(() => {
                setIsVisible(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [stockErrorMessage, stockRequestInfo.enabled]);

    return (
        <>

            <div className={`modal ${show && 'show'} ${viewImageOption && 'imgbg'}`}>
                <div onClick={close}></div>
                <div className={`customize-modal ${show && 'show'}`}>
                    <div className="content">
                        {modalType === 1 && variant != undefined
                            ?
                            <VariantModal
                                currency={currency}
                                variant={variant}
                                product={product}
                                shopSettings={shopSettings}
                                clickClose={clickClose}
                                addVariantBasket={addVariantBasket}
                            />
                            :
                            <ContentModal />
                        }
                        {stockRequestInfo.enabled && stockErrorMessage !== null && (
                            <div className="stockErrorMessage">
                                <p className={`fade ${isVisible ? 'visible' : 'hidden'}`}>
                                    {stockErrorMessage}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div >
        </>
    )
}

type OptionProps = {
    currency: string,
    option: CustomizeProduct,
    hasValue: (title: string) => any[],
    isSelected: (title: string, option: any) => boolean,
    addOption: (title: string, option: any) => void,
    disabled: boolean,
    viewImage: (option: any) => void,
    setViewImageModalLeft: (option: any) => void,
    mouseOutLeft: () => void
}

const Option = ({ currency, option, hasValue, isSelected, addOption, disabled, viewImage, setViewImageModalLeft, mouseOutLeft }: OptionProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const clickOpen = () => {
        if (!disabled) setIsOpen(true);
    }

    const clickClose = () => {
        if (!disabled) setIsOpen(false);
    }

    const clickOption = (id: string, option: any) => {
        clickClose();
        //customize.showPreviewImage && viewImage(option)
        addOption(id, option)
    }

    const overOption = (option: any) => {
        clickOpen()
        setViewImageModalLeft(option)
    }
    const mouseOutOption = () => {
        clickOpen()
        mouseOutLeft()
    }

    const getValue = hasValue(option.Id);

    if (getValue.length == 0 && disabled) return <></>;

    if (isOpen == false) {
        return (
            <div className={`container-option ${getValue.length > 0 && 'grey'}`} onClick={clickOpen}>
                <span>
                    <span className="arrow"><ArrowDownIcon /></span>
                    <p className="option-name">{option.Title}</p></span>
                <span>
                    {getValue.length > 0 && <>
                        <p className="option-value">{getValue[0].option.Title}</p>
                        {showImageAtCustomizeSelection && getValue[0].option.Image &&
                            <img id="box-image-option" className={'box-image-option'} src={getValue[0].option.Image} />
                        }
                        {option.type == 'image' && <span className="option-image"></span>}
                        <GreenTickIcon />
                    </>}
                </span>
            </div>
        )
    }
    else return (
        <div className={`container-option open`}>
            <span >
                <span className="arrow"><ArrowDownIcon /></span>
                <p className="option-name">{option.Title}</p>
            </span>
            {option.Groups[0].GroupType == 0 &&
                <>
                    <TextOptions currency={currency} addOption={clickOption} isSelected={isSelected} id={option.Id} options={option.Groups} />
                    {setupCustomSectionOption.enabled && <SetupCustomSectionOption option={option} />}
                </>
            }
            {option.Groups[0].GroupType == 1 &&
                <ImageOptions groupTitle={option.Title} currency={currency} addOption={clickOption} isSelected={isSelected} id={option.Id} options={option.Groups}
                    setViewImageModalLeft={overOption} mouseOutOption={mouseOutOption} clickClose={clickClose} />
            }
        </div>
    )
}

const showPrice = (currency: string, from: number, to: number) => {
    if (from == null && to == null) return <span></span>
    if (from == null && to != null)
        if (to != 0) return <span>{getCurrencyValue(currency, `${to}`)}</span>
    if (from != null && to == null)
        if (from != 0) return <span>{getCurrencyValue(currency, `${from}`)}</span>
    if (from != null && to != null) {
        if (from != 0 && to != 0 && from != to) {
            if ((customize.showFromPrice && from != to) || digitalagent) return <span>{getCurrencyValue(currency, `${from}`)} </span>
            else return <span> <b>{getCurrencyValue(currency, `${from}`)}</b> <>'-' <del>{getCurrencyValue(currency, `${to}`)}</del></></span>
        }
        if (from != 0 && to != 0 && from == to) return <span>{getCurrencyValue(currency, `${from}`)}</span>
        if (from != 0 && to == 0) return <span>{getCurrencyValue(currency, `${from}`)}</span>
    }
}

type TextOptionsProps = {
    currency: string,
    id: string,
    options: Group[],
    isSelected: (title: any, option: any) => boolean,
    addOption: (title: any, option: any) => void,
}

const TextOptions = ({ currency, id, options, isSelected, addOption }: TextOptionsProps) => {
    return (
        <div className="options text">
            {options.length == 1 && (
                <>{options[0].Options.map(o =>
                    <div className={`option-item ${isSelected(id, o) && 'selected'}`} onClick={() => addOption(id, o)}>
                        <div>
                            <span>{o.Title}</span>
                            {showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional) && showPrice(currency, o.Price.From, o.Price.To)}
                        </div>
                    </div>
                )}</>
            )}

            {options.length > 1 && (
                <>{options.map(g =>
                    <div className="option-row">
                        <div className="head">
                            <span>{g.Title}</span>
                            <>{showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional) && showPrice(currency, g.Price.From, g.Price.To)}</>
                            {/* {customize.showFromPrice ? (<span><b>From {g.Price !== null && getCurrencyValue(currency, `${g.Price?.To}`)}</b></span>)
                                : <>
                                    {(g.PriceType == 0 && showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional)) && (
                                        <span>{g.Price !== null && getCurrencyValue(currency, `${g.Price?.To}`)}  {g.OldPrice !== null && getCurrencyValue(currency, `${g.OldPrice?.To}`)}</span>
                                    )}
                                    {(g.PriceType == 1 && showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional)) && (
                                        <span><b>{g.Price !== null && getCurrencyValue(currency, `${g.Price?.To}`)}</b>   <del>{g.OldPrice !== null && getCurrencyValue(currency, `${g.OldPrice?.To}`)}</del></span>
                                    )}
                                </>} */}
                            {g.Options.map(o => (
                                <div className={`option-item ${isSelected(id, o) && 'selected'}`} onClick={() => addOption(id, o)}>
                                    <div>
                                        <span>{o.Title}</span>
                                        {showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional) && showPrice(currency, o.Price?.To, o.Price?.From)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}</>
            )}
        </div>
    )
}

type ImageOptionsProps = {
    currency: string,
    id: string,
    options: Group[],
    isSelected: (title: any, option: any) => boolean,
    addOption: (title: any, option: any) => void,
    setViewImageModalLeft: (option: any) => void,
    mouseOutOption: () => void,
    clickClose: () => void,
    groupTitle: string
}

const ImageOptions = ({ currency, id, options, addOption, isSelected, setViewImageModalLeft, mouseOutOption, clickClose, groupTitle }: ImageOptionsProps) => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
    const [animationDirection, setAnimationDirection] = useState('left');
    const isMobile = innerWidth <= 1025;
    const [touchStartX, setTouchStartX] = useState(0);
    const [swipePosition, setSwipePosition] = useState(0);
    const [touchesAtStart, setTouchesAtStart] = useState(0);
    const [loadedImages, setLoadedImages] = useState<{ [key: string]: boolean }>({});

    const handleArrowClick = (direction: string) => {
        setAnimationDirection(direction);
    }
    const handleTouchStart = (e) => {
        setTouchesAtStart(e.touches.length);
        if (e.touches.length === 1) {
            const touchStart = e.touches[0];
            setTouchStartX(touchStart.clientX);
        }
    }
    const handleTouchEnd = (e) => {

        if (touchesAtStart > 1) {
            setSwipePosition(0);
            return;
        }

        if (e.changedTouches.length === 1) {
            const touchEnd = e.changedTouches[0];
            const endX = touchEnd.clientX;
            !e.target.classList.contains('box-button') && handleSwipe(endX);
            setSwipePosition(0);
            setTouchesAtStart(0);
        }
    }
    const handleTouchMove = (e) => {
        if (touchesAtStart > 1) return;

        const touchMove = e.touches[0];
        const diffX = touchMove.clientX - touchStartX;
        if (currentIndex == 0 && diffX > 0) return;
        if (currentIndex == options[currentGroupIndex].Options.length - 1 && diffX < 0) return;
        setSwipePosition(diffX);
    }
    const handleSwipe = (endX: number) => {
        const swipeThreshold = 150;
        const diffX = endX - touchStartX;
        if (Math.abs(diffX) > swipeThreshold) {
            if (diffX > 0) {
                setAnimationDirection('right');
                if (currentIndex > 0) prevImage();
            } else {
                setAnimationDirection('left');
                if (currentIndex < options[currentGroupIndex].Options.length - 1) nextOption();
            }
        }
    };

    const handleEvento = (event, o) => {
        if (isMobile) {
            event.preventDefault();
        } else {
            setViewImageModalLeft(o)
        }
    }

    const nextOption = () => {
        setCurrentIndex((prevIndex) => {
            const nextIndex = prevIndex + 1;
            return nextIndex >= options[currentGroupIndex].Options.length ? 0 : nextIndex;
        });
    }
    const prevImage = () => {
        setCurrentIndex((prevIndex) => {
            const prevIndexValue = prevIndex - 1;
            return prevIndexValue < 0 ? options[currentGroupIndex].Options.length - 1 : prevIndexValue;
        });
    }
    const changeGroup = (index: number) => {
        setCurrentGroupIndex(index);
        setCurrentIndex(0);
    }

    return (
        <div className="options image">
            {options.length == 1 && (
                <>
                    {isMobile ? (
                        <div className="box-container">
                            <button className="arrow-back" onClick={clickClose}>
                                <ArrowLeftIcon color="#fff" />
                            </button>

                            <div
                                className="grid-options-colors"
                                onTouchStart={handleTouchStart}
                                onTouchEnd={handleTouchEnd}
                                onTouchMove={handleTouchMove}
                            >
                                {options[0].Options.map((o, i) =>
                                    currentIndex === i && (
                                        <React.Fragment key={i}>
                                            <button
                                                className={`box-button ${currentIndex === i && "active"}`}
                                                onClick={() => addOption(id, o)}
                                            >
                                                Select
                                            </button>
                                            <span
                                                data-tooltip={showOptionTextHover ? o.Title : null}
                                                className={`box single ${animationDirection === "right"
                                                    ? "from-right"
                                                    : "from-left"
                                                    }`}
                                            >
                                                <span
                                                    className="box-image"
                                                    style={{
                                                        transform: `translateX(${swipePosition}px)`,
                                                        transition: `transform 0.3s ease`,
                                                    }}
                                                >
                                                    <div className="box-child">
                                                        {loadedImages[o.Image] ? (
                                                            <CarouselArrows
                                                                nextOption={nextOption}
                                                                prevImage={prevImage}
                                                                currentIndex={currentIndex}
                                                                currentGroupIndex={currentGroupIndex}
                                                                options={options}
                                                                handleArrowClick={handleArrowClick}
                                                            />
                                                        ) : (
                                                            <div className="loader-customize"></div>
                                                        )}
                                                        <img
                                                            src={o.Image && o.Image.trim() !== "" ? o.Image : NoImageMultiStore}
                                                            onLoad={() =>
                                                                setLoadedImages((prev) => ({
                                                                    ...prev,
                                                                    [o.Image]: true,
                                                                }))
                                                            }
                                                            onError={(e) => {
                                                                e.currentTarget.src = NoImageMultiStore;
                                                                setLoadedImages((prev) => ({ ...prev, [o.Id]: false }));
                                                            }}

                                                        />
                                                    </div>
                                                    {loadedImages[o.Image] && (
                                                        <>
                                                            <span className="box-title">{o.Title}</span>
                                                            <IndexPoints
                                                                currentIndex={currentIndex}
                                                                currentGroupIndex={currentGroupIndex}
                                                                options={options}
                                                            />
                                                        </>
                                                    )}
                                                </span>
                                            </span>
                                        </React.Fragment>
                                    )
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="box-container">
                            {customize.inlineOptions ? (
                                <div className="grid-options-colors">
                                    {options[0].Options.map((o, i) => (
                                        <span
                                            key={i}
                                            data-tooltip={showOptionTextHover ? o.Title : null}
                                            className={`box single ${isSelected(id, o) && "selected"}`}

                                        >
                                            <span
                                                className="box-image"
                                                onClick={() => addOption(id, o)}
                                            >
                                                <div className="box-child"
                                                    onMouseEnter={(e) => handleEvento(e, o)}
                                                    onMouseOut={mouseOutOption}
                                                >
                                                    {loadedImages[o.Image] ? null : (
                                                        <div className="loader-customize single"></div>
                                                    )}
                                                    <img
                                                         src={o.Image && o.Image.trim() !== "" ? o.Image : NoImageMultiStore}
                                                        onLoad={() =>
                                                            setLoadedImages((prev) => ({
                                                                ...prev,
                                                                [o.Image]: true,
                                                            }))
                                                        }
                                                        onError={(e) => {
                                                            e.currentTarget.src = NoImageMultiStore;
                                                            setLoadedImages((prev) => ({ ...prev, [o.Id]: false }));
                                                        }}
                                                    />
                                                </div>
                                            </span>
                                        </span>
                                    ))}
                                </div>
                            ) : (
                                <div className="box-image-rows grid gap-4 max-h-52">
                                    {options[0].Options.map((o, i) => (
                                        <span
                                            key={i}
                                            data-tooltip={showOptionTextHover ? o.Title : null}
                                            className={`box ${isSelected(id, o) && "selected"}`}
                                        >
                                            <span
                                                className="box-image"
                                                onClick={() => addOption(id, o)}
                                                onMouseEnter={(e) => handleEvento(e, o)}
                                                onMouseOut={mouseOutOption}
                                            >
                                                {loadedImages[o.Image] ? null : (
                                                    <div className="loader-customize single"></div>
                                                )}
                                                <img
                                                    src={o.Image && o.Image.trim() !== "" ? o.Image : NoImageMultiStore}
                                                    className={`${isSelected(id, o) && "selected"}`}
                                                    onLoad={() =>
                                                        setLoadedImages((prev) => ({
                                                            ...prev,
                                                            [o.Image]: true,
                                                        }))
                                                    }
                                                    onError={(e) => {
                                                        e.currentTarget.src = NoImageMultiStore;
                                                        setLoadedImages((prev) => ({ ...prev, [o.Id]: false }));
                                                    }}
                                                />
                                            </span>
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}

            {(options.length > 1 && window.innerWidth > 1025) && (
                <>{options.map((g, i) =>
                    (g?.Options != null && g?.Options?.length > 0) &&
                    <div className="option-row">
                        <div className="head">
                            <span>{g.Title}</span>
                            {customize.showFromPrice ? (<span><b>From {g.Price !== null && getCurrencyValue(currency, `${g.Price.To}`)}</b></span>)
                                : <>
                                    {showPriceOptions && (!showOldPriceCustomizeModal || (showOldPriceCustomizeModal && g.Price == g.OldPrice)) && (!isNonTransactional || showPriceshowPriceTransactional) && showPrice(currency, g.Price.From, g.Price.To)}
                                    {showOldPriceCustomizeModal && g.Price !== g.OldPrice &&
                                        <>
                                            {(g.PriceType == 0 && showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional)) && (
                                                <span>{g.Price !== null && getCurrencyValue(currency, `${g.Price.To}`)} - {g.OldPrice !== null && getCurrencyValue(currency, `${g.OldPrice.To}`)}</span>
                                            )}
                                            {(g.PriceType == 1 && showPriceOptions && (!isNonTransactional || showPriceshowPriceTransactional)) && (
                                                <span><b>{g.Price !== null && getCurrencyValue(currency, `${g.Price.To}`)}</b>   <del>{g.OldPrice !== null && getCurrencyValue(currency, `${g.OldPrice.To}`)}</del></span>
                                            )}
                                        </>
                                    }
                                </>}
                        </div>
                        {customize.inlineOptions ?
                            <div className="box-container">
                                <div className="grid-options-colors">
                                    {g.Options.map((o, i) =>
                                        <>
                                            <span data-tooltip={showOptionTextHover ? o.Title : null} className={`box ${isSelected(id, o) && 'selected'} ${i == currentIndex && 'active'}`}>
                                                <span className="box-image" onClick={() => { window.innerWidth > 1025 && addOption(id, o) }}>
                                                    {!loadedImages[o.Image] && (
                                                        <div className="loader-customize"></div>
                                                    )}
                                                    <img id="box-image-mouse" onMouseEnter={(e) => { window.innerWidth > 1025 && handleEvento(e, o) }}
                                                        onMouseOut={() => window.innerWidth > 1025 && mouseOutOption()}
                                                        className={`${isSelected(id, o) && 'selected'}`}  src={o.Image && o.Image.trim() !== "" ? o.Image : NoImageMultiStore}
                                                        onLoad={() => { setLoadedImages(prevState => ({ ...prevState, [o.Image]: true })) }}
                                                        onError={(e) => {
                                                            e.currentTarget.src = NoImageMultiStore;
                                                            setLoadedImages((prev) => ({ ...prev, [o.Id]: false }));
                                                        }}
                                                    />
                                                </span>
                                            </span>
                                        </>
                                    )}
                                </div>
                            </div> :
                            <div className="box-container">
                                <div className="box-image-rows grid gap-4 max-h-52">
                                    {g.Options.map((o, i) => <span data-tooltip={showOptionTextHover ? o.Title : null} className={`box ${isSelected(id, o) && 'selected'} ${i == currentIndex && 'active'}`}>
                                        <span className="box-image" onClick={() => { window.innerWidth > 1025 && addOption(id, o) }}>
                                            <img id="box-image-mouse" onMouseEnter={(e) => window.innerWidth > 1025 && handleEvento(e, o)} onMouseOut={() => { window.innerWidth > 1025 && mouseOutOption() }}
                                                className={`${isSelected(id, o) && 'selected'}`}  src={o.Image && o.Image.trim() !== "" ? o.Image : NoImageMultiStore}
                                            />
                                        </span>
                                    </span>)}
                                </div>
                            </div>
                        }
                    </div>
                )}</>
            )}
            {options.length > 1 && isMobile && (
                <div className="option-row">
                    <div className="box-container">
                        {
                            innerWidth <= 1025 && (
                                <button className="arrow-back" onClick={clickClose}>
                                    <ArrowLeftIcon color="#fff" />
                                </button>
                            )
                        }
                        <div className="grid-options-colors" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                            <GroupSelector showPriceOptions={showPriceOptions} getCurrencyValue={getCurrencyValue} currency={currency} options={options} currentGroupIndex={currentGroupIndex} changeGroup={changeGroup} groupTitle={groupTitle} />

                            {options[currentGroupIndex]?.Options.map((o, i) => (

                                currentIndex == i && (
                                    <>
                                        {
                                            isMobile && (
                                                <button className={`box-button ${currentIndex == i && 'active'}`} onClick={() => addOption(id, o)}>Select</button>
                                            )
                                        }
                                        <span
                                            key={i}
                                            data-tooltip={showOptionTextHover ? o.Title : null}
                                            className={`box ${animationDirection === 'right' ? 'from-right' : 'from-left'}`}
                                        >
                                            <span className="box-image" style={{ transform: `translateX(${swipePosition}px)`, transition: `transform 0.3s ease` }}>

                                                <div className="box-child">
                                                    {loadedImages[o.Image] && (
                                                        <CarouselArrows nextOption={nextOption} prevImage={prevImage} currentIndex={currentIndex} currentGroupIndex={currentGroupIndex} options={options} handleArrowClick={handleArrowClick} />
                                                    )}
                                                    {!loadedImages[o.Image] && (
                                                        <div className="loader-customize"></div>
                                                    )}
                                                    <img
                                                        id="box-image-mouse"
                                                        src={o.Image && o.Image.trim() !== "" ? o.Image : NoImageMultiStore}
                                                        onLoad={() => { setLoadedImages(prevState => ({ ...prevState, [o.Image]: true })) }}
                                                        onError={(e) => {
                                                            e.currentTarget.src = NoImageMultiStore;
                                                            setLoadedImages((prev) => ({ ...prev, [o.Id]: false }));
                                                        }}
                                                    />
                                                </div>
                                                {isMobile && loadedImages[o.Image] && (
                                                    <>
                                                        <span className="box-title">{o.Title}</span> <IndexPoints currentIndex={currentIndex} currentGroupIndex={currentGroupIndex} options={options} />
                                                    </>
                                                )}
                                            </span>
                                        </span>
                                    </>
                                )

                            ))}
                        </div>
                    </div>


                </div>
            )}
        </div>
    )
}

type ViewImageModalOptionProps = {
    clickCloseViewImage: () => void,
    option: any
}
const ViewImageModalOption = ({ clickCloseViewImage, option }: ViewImageModalOptionProps) => {
    return (
        <>{option && option.Image != null &&
            <>
                <div className="grid grid-cols-1 gap-1">
                    <div><span className="inline-flex items-center px-4 py-5 float-right" onClick={clickCloseViewImage}><ArrowLeftIcon /></span></div>
                </div>
                <div className="imageZoomOption">
                    <img className="" src={option.Image} alt="" />
                    <div className="p-5">
                        <p className="mb-3">{option.Title}</p>
                    </div>
                </div>
            </>
        }
        </>
    )
}
type ViewImageModalLeftOptionProps = {
    option: any,
}

const ViewImageModalLeft = ({ option }: ViewImageModalLeftOptionProps) => {
    return (
        <>
            {option && option.Image != null &&
                <>
                    <div className="customize-modal-left">
                        <img src={option.Image} />
                        <p>{option.Title}</p>
                    </div>
                </>
            }
        </>
    )
}

